import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { EnvironmentList } from '../../types/environment';

const EnvironmentEndpoint = `environments`;

export const useGetEnvironments = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<EnvironmentList>
  >(`${EnvironmentEndpoint}?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};
